module.exports = __webpack_public_path__ + "static/media/N2.2cb65c78.png";